export const buildQualifierIdTemplate = (qualifier, id) =>
  id && qualifier ? `${qualifier} - ${id}` : `${qualifier}${id}`;
